
















































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { BSpinner } from "bootstrap-vue";
import { CallLogType } from "@/store/modules/enums";
import { uploadCallFile, archiveCallFile, callFileUrl } from "@/storage";
import { fileIcon, randomId } from "@/utils";
import AudioRecorderPopover from "@/components/AudioRecorderPopover.vue";
import AudioPlayer from "@/components/AudioPlayer.vue";

@Component({
  components: { BSpinner, AudioRecorderPopover, AudioPlayer },
})
export default class Call extends Vue {
  @Prop(String) readonly publicId!: string;
  chat = {
    entity: null,
    messages: Array<any>(),
  };
  text = "";
  interval = 0;
  showAudioRecorder = false;
  voiceStorageId: string | null = null;
  async getCall(showLoading?: boolean) {
    // SET FORM DATA
    const params = new FormData();
    params.append("publicId", this.publicId);
    // GET CALL ASYNC
    this.$store.commit("main/SET_LOADING", showLoading);
    try {
      const { data } = await Vue.axios.post("callcenter/call/chat", params);
      if (!showLoading) {
        const officeMessageCount = data.messages.filter(
          (item: any) => item.typeId === CallLogType.OFFICE_TO_CALLER_MESSAGE
        ).length;
        if (officeMessageCount > this.officeMessageCount) {
          this.audio.play();
        }
      }
      this.chat = data;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
    //
  }
  async send() {
    if (!this.text) return;
    this.$store.commit("main/SET_LOADING", true);
    try {
      // SET FORM DATA
      const params = new FormData();
      params.append("publicId", this.publicId);
      params.append("comment", this.text);
      params.append("typeId", CallLogType.CALLER_TO_OFFICE_MESSAGE);
      //
      await Vue.axios.post("callcenter/call/chat/message", params);
      this.text = "";
      this.getCall(false);
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async savePhoto() {
    if (this.photoInput.files) {
      this.$store.commit("main/SET_LOADING", true);
      try {
        const photo = this.photoInput.files[0];
        await uploadCallFile(
          this.publicId,
          photo,
          CallLogType.SECURE_CHAT_PHOTO
        );
        this.photoInput.value = "";
        await this.getCall(true);
      } catch (error) {
        console.log(error);
      }
    }
  }
  async saveFile() {
    if (this.fileInput.files) {
      this.$store.commit("main/SET_LOADING", true);
      try {
        const file = this.fileInput.files[0];
        await uploadCallFile(this.publicId, file, CallLogType.SECURE_CHAT_FILE);
        this.fileInput.value = "";
        await this.getCall(true);
      } catch (error) {
        console.log(error);
      }
    }
  }
  async saveVoice(data: Blob) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const f: any = data;
      f.name = `VOICE_${randomId(6)}.webm`;
      f.lastModifiedDate = new Date();
      await uploadCallFile(
        this.publicId,
        data as File,
        CallLogType.SECURE_CHAT_VOICE
      );
      await this.getCall(true);
    } catch (error) {
      console.log(error);
    }
  }
  openFile(item: any) {
    const url = callFileUrl(item.fileStorageId);
    window.open(url, "_blank");
  }
  archiveFile(item: any) {
    this.$modal.show("dialog", {
      title: `Delete "${item.fileName}"`,
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$store.commit("main/SET_LOADING", true);
            try {
              await archiveCallFile(item.fileId);
              this.getCall(false);
              this.$modal.hide("dialog");
            } catch (error) {
              console.log(error);
            } finally {
              this.$store.commit("main/SET_LOADING", false);
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  getBubbleClass(item: any) {
    switch (item.type) {
      case CallLogType.OFFICE_TO_CALLER_MESSAGE:
        return "from-them";
      case CallLogType.CALLER_TO_OFFICE_MESSAGE:
        return "from-me";
      case CallLogType.SECURE_CHAT_PHOTO:
      case CallLogType.SECURE_CHAT_VOICE:
      case CallLogType.SECURE_CHAT_FILE:
        if (item.user === "system") {
          return "from-me";
        } else {
          return "from-them";
        }
    }
  }
  get officeMessageCount() {
    return this.chat.messages.filter(
      (item) => item.typeId === CallLogType.OFFICE_TO_CALLER_MESSAGE
    ).length;
  }
  get audio() {
    return document.getElementById("chat-audio") as HTMLAudioElement;
  }
  get LogType() {
    return CallLogType;
  }
  get photoInput() {
    return document.getElementById("photo-input") as HTMLInputElement;
  }
  get fileInput() {
    return document.getElementById("file-input") as HTMLInputElement;
  }
  get fileIcon() {
    return fileIcon;
  }
  mounted() {
    this.getCall(true);
    this.interval = setInterval(this.getCall, 5000);
  }
  beforeDestroy() {
    clearInterval(this.interval);
  }
}
